import React from 'react';

// components and helpers
import ComponentWrapper from '../containers/ComponentWrapper';
import Profile from '../components/User/Profile';

// mui

const ProfileView: React.FC = () => {
    return <Profile />;
};

export default ComponentWrapper(ProfileView);
